class CapsulesNavSlider extends HTMLElement {
    constructor() {
        super();
        this.flkty = null;
        this.resizeHandler = () => this.initSlider();
    }

    connectedCallback() {
        if (!window.theme || !window.theme.Flickity) return;
        this.initSlider();
        window.addEventListener('resize', this.resizeHandler);
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.resizeHandler);
        this.destroySlider();
    }

    get items() {
        return Array.from(this.querySelectorAll('[data-slide]'));
    }

    initSlider() {
        if (!this.items.length || this.items.length <= 1) {
            this.destroySlider();
            return;
        }

        if (this.flkty) {
            this.flkty.resize();
            return;
        }

        this.classList.add('carousel', 'carousel--mobile');

        this.flkty = new window.theme.Flickity(this, {
            cellSelector: '[data-slide]',
            pageDots: false,
            contain: true,
            draggable: true,
            groupCells: false,
            wrapAround: false,
            percentPosition: false,
            cellAlign: 'center',
            prevNextButtons: true,
            adaptiveHeight: true,
            groupCells: true,
        });
    }

    destroySlider() {
        if (this.flkty) {
            this.flkty.destroy();
            this.flkty = null;
        }
    }
}

if (!customElements.get('capsules-nav-slider')) {
    customElements.define('capsules-nav-slider', CapsulesNavSlider);
}
